<template>
  <div class="system-box center-content-border">
    <h3>系统</h3>
    <div class="system-content">
      <el-row class="content" v-if="sysList && sysList.length">
        <el-col class="list" v-for="item in sysList" :span="8" :key="item.id">
          <el-image v-if="item.icon" :src="item.icon" fit="contain" @click="toDetailpage(item)"></el-image> 
          <div v-else class="error-image" @click="toDetailpage(item)">
            <svg-icon icon-class="application" class-name="icon-style"></svg-icon>
          </div>
          <span v-autotip="item.sysName"  @click="toDetailpage(item)"></span>
        </el-col>
      </el-row> 
      <div class="no-result" v-else>暂无数据</div>
    </div>
  </div>
</template>

<script>
import { getPermissionApi } from '@/util/api'

export default {
  data() {
    return {
      sysList: []
    }
  }, 
  mounted() {
    getPermissionApi().then(res => {
      if (res.code === 0) {
        console.log(res.data)
        this.sysList =  res.data.filter(v => v.sysCode != "poros_data") || [];
      }
    })
  }, 
  methods: {
    toDetailpage(item) {
      if(!item.sysIndex) {
        return this.$message.error("该系统尚未配置url地址！")
      }
      window.open(item.sysIndex)
    },
  } 
}
</script>

<style scoped lang="less">
.system-box{
  margin-right: 20px;
  background: #fff;
  h3{
    margin-bottom: 12px;
  } 
  .system-content{
    min-height: 202px;
    height: 25.75vh;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .content{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow: auto;
    width:  100%;
    min-height: 224px;
    height: 28vh;
    padding: 0 10px 10px;
    .list{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .el-image, .error-image{
        width: 64px;
        height: 64px;
        cursor: pointer;
        background: @sys-default-icon-bg;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .error-image{ 
        .icon-style{
          width: 26px;
          height: 26px;
          fill: @icon-color;
        }
      }
      span{
        cursor: pointer;
        font-size: 13px;
        color: @title-color;
        height: 18px;
        margin: 10px 0 16px;
        display: inline-block;
        text-align: center;
        width: 80%;
      }
      /deep/ .el-image__inner{
        background: @sys-default-icon-bg;
      }
    }
  }
}
</style>
